import { useEffect, useRef, useState } from "react";
import { FolderOpen, X } from "lucide-react";

/**
 * Brauzerning o'zida kamera — telefonda ham.
 *
 * `capture` li fayl maydoni telefonda alohida kamera ilovasini ochadi;
 * xotira kam bo'lsa tizim shu paytda brauzer sahifasini o'chiradi va
 * qaytganda sahifa qayta yuklanib, foto yo'qoladi. Bu yerda sahifa
 * tashlab ketilmaydi. `getUserMedia` faqat https yoki localhost da bor
 * (mahalliy tarmoqda — `make ui-lan`).
 */
export function CameraDialog({ onShot, onClose, onFallback }) {
  const video = useRef(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let stream = null;
    let gone = false;
    if (!navigator.mediaDevices?.getUserMedia) {
      setError("Bu sahifada kamera ochilmaydi (https kerak)");
      return;
    }
    navigator.mediaDevices
      .getUserMedia({
        video: { facingMode: "environment", width: { ideal: 1920 }, height: { ideal: 1440 } },
        audio: false,
      })
      .then((s) => {
        if (gone) return s.getTracks().forEach((t) => t.stop());
        stream = s;
        video.current.srcObject = s;
      })
      .catch(() => setError("Kameraga ruxsat berilmadi"));
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => {
      gone = true;
      stream?.getTracks().forEach((t) => t.stop());
      window.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  const shoot = () => {
    const v = video.current;
    const canvas = document.createElement("canvas");
    canvas.width = v.videoWidth;
    canvas.height = v.videoHeight;
    canvas.getContext("2d").drawImage(v, 0, 0);
    canvas.toBlob((blob) => {
      canvas.width = canvas.height = 0;
      if (blob) onShot(new File([blob], "kamera.jpg", { type: "image/jpeg" }));
      onClose();
    }, "image/jpeg", 0.92);
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-black text-white">
      <div className="relative min-h-0 flex-1">
        {error ? (
          <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
            <p className="text-base text-sky-100">{error}</p>
            <button
              onClick={onFallback}
              className="flex items-center gap-2 rounded-xl bg-sky-600 px-4 py-2.5 text-sm font-semibold hover:bg-sky-500"
            >
              <FolderOpen className="h-4 w-4" /> Fayldan tanlash
            </button>
          </div>
        ) : (
          <video
            ref={video}
            autoPlay
            playsInline
            muted
            onLoadedData={() => setReady(true)}
            className="absolute inset-0 h-full w-full object-cover sm:object-contain"
          />
        )}
        <button
          onClick={onClose}
          title="Yopish"
          className="absolute right-4 top-4 z-10 rounded-full bg-black/50 p-2.5 hover:bg-black/70"
        >
          <X className="h-6 w-6" />
        </button>
      </div>

      {!error && (
        <div className="flex shrink-0 justify-center py-6">
          <button
            onClick={shoot}
            disabled={!ready}
            title="Suratga olish"
            className="h-[72px] w-[72px] rounded-full border-4 border-white bg-white/25 transition-transform active:scale-90 disabled:opacity-40"
          />
        </div>
      )}
    </div>
  );
}
